var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(item,index){return _c('m-btn',{key:index,staticClass:"ml-10",attrs:{"active":index === _vm.selected,"label":item[_vm.label],"mode":"btn-1"},nativeOn:{"click":function($event){return _vm.getTabInfo(item, index)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee805856","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/tab/index.vue
// module id = null
// module chunks = 